module.exports = __webpack_public_path__ + "static/media/video-example-right.bcf52aa2.png";